import { render, staticRenderFns } from "./CbsFormDesignerFieldPalette.vue?vue&type=template&id=e119995c&scoped=true"
import script from "./CbsFormDesignerFieldPalette.vue?vue&type=script&lang=js"
export * from "./CbsFormDesignerFieldPalette.vue?vue&type=script&lang=js"
import style0 from "./CbsFormDesignerFieldPalette.vue?vue&type=style&index=0&id=e119995c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e119995c",
  null
  
)

export default component.exports